module.exports = __webpack_public_path__ + "static/media/browse - Copy.78928009.jpg";